
import React from 'react';
import { User, Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface ProfileHeaderProps {
  user: User;
  language: Language;
  onBack: () => void;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ user, language, onBack }) => {
  const t = TRANSLATIONS[language];
  const isRtl = language === 'ar';

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
      <div className="flex items-center gap-4">
        <button onClick={onBack} className="w-10 h-10 rounded-xl bg-white dark:bg-white/5 hover:bg-slate-100 flex items-center justify-center text-slate-500 transition-colors shadow-sm">
            <i className={`fas fa-arrow-${isRtl ? 'right' : 'left'}`}></i>
        </button>
        <div>
          <h1 className="text-2xl font-black text-slate-800 dark:text-white">{t.dashboardTitle}</h1>
          <p className="text-xs text-slate-500 dark:text-slate-400 font-medium">User ID: {user.id.substring(0, 8)}</p>
        </div>
      </div>
    </div>
  );
};
export default ProfileHeader;
